import React, { memo } from 'react'
import { GraphQLError, Nullable } from 'types'
import { getErrorText } from 'services/error'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@mui/material'

interface IServerErrorProps {
  error: Nullable<Error | GraphQLError | string>
  'data-cy'?: string
}

const useStyles = makeStyles()(theme => ({
  serverError: {
    margin: theme.spacing(2, 0),
    color: theme.palette.error.main,
  },
}))

// this looks duplicated with FormErrorSummary
// TODO: make FormErrorSummary take data from a form and use ServerError internally so the two components are combined

const ServerError = ({ error, ...props }: IServerErrorProps) => {
  const { classes } = useStyles()
  if (!error) return null

  return (
    <Typography variant="body2" className={classes.serverError} data-cy={props['data-cy'] || 'server-error'}>
      {typeof error === 'string' ? error : getErrorText(error)}
    </Typography>
  )
}

export default memo(ServerError)
